<template>
    <div class="profileSection">
        <loader v-if="pageLoader"></loader>
        <div class="row justify-content-center">
            <div class="col-12 col-md-10">
                <div class="bg-white border-radius-5 p-3 mt-4">
                    <div class="row align-items-center" v-if="get_user.profile">
                        <div class="col-12 col-md-3">
                            <div class="text-center h-100 border-right card-body">
                                <div class="position-relative">
                                    <span class="mainInfoUser"><img class="mb-3" src="../../../../static/website/images/placeholder.jpg" alt="Image" v-if="get_user.profile.profile_pic == ''">
                                    <img class="mb-3" :src="$env_var.LOCAL_FACADE_SERVER_FULL_ADDRESS +'/get/docs?type=profile_'+get_user.profile.user_id+'&doc='+get_user.profile.profile_pic" alt="Image" v-else></span>
                                    <form method="post" enctype="multipart/form-data" id="UploadDocuments">
                                        <div class="upload-btn-wrapper">
                                          <button class="btn"><feather type="edit"></feather></button>
                                          <input type="file" name="document" @change="onFileChange($event.target.files[0])" ref="documemnts" v-validate="docSubmitted ? 'required' : ''"/>
                                          <p class="text-center alert alert-danger mt-3" v-if="docSubmitted" v-for="error in errors.collect('document')">{{ error }}</p>
                                        </div>
                                    </form>
                                </div>
                               <h5>{{ (get_user.profile.firstname || '') + ' ' + (get_user.profile.lastname || '').trim() || '-'}}</h5>
                               <p class="mb-1">{{ get_user.email || '-'}}</p>
                               <!-- <p class="mb-0">Finvasia Centre D 179, Sector 74, Mohali Punjab 160055</p> -->
                            </div>
                        </div>
                        <div class="col-12 col-md-9">
                            <div class="card-body pl-3">
                                <div class="row" v-if="editProfile">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>First Name</label>
                                            <div class="position-relative">
                                               <input type="text" placeholder="Enter First Name" name="First Name" v-model="fname" class="float-field form-control" v-validate="'required'">
                                            </div>
                                            <p class="error" v-if="submitted && editProfile && errors.has('First Name')">{{  errors.first('First Name') }}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>Last Name</label>
                                            <div class="position-relative">
                                               <input type="text" placeholder="Enter Last Name" name="Last Name" v-model="lname" class="float-field form-control" v-validate="'required'">
                                            </div>
                                            <p class="error" v-if="submitted && editProfile && errors.has('Last Name')">{{  errors.first('Last Name') }}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group" :class="[{'border-bottom pb-3':!editProfile}]">
                                            <label>Address</label>
                                            <div class="position-relative">
                                               <input type="text" placeholder="Enter address" name="address" v-model="address" class="float-field form-control" maxlength="100" v-validate="'required|max:100'">
                                            </div>
                                            <p class="error" v-if="submitted && editProfile && errors.has('address')">{{  errors.first('address') }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                   <div class="col-12 col-md-4">
                                        <div class="form-group" :class="[{'border-bottom pb-3':!editProfile}]">
                                            <label>Gender</label>
                                            <p class="mb-0" v-if="!editProfile">
                                                <span v-if="get_user.profile.gender == 'F'">Female</span>
                                                <span v-else-if="get_user.profile.gender == 'M'">Male</span>
                                                <span v-else-if="get_user.profile.gender == 'O'">Other</span>
                                                <span v-else>N/A</span>
                                            </p>
                                            <div class="position-relative" v-if="editProfile">
                                               <!-- <input placeholder="Enter" name="password" class="float-field form-control"> -->
                                               <select v-model="gender" name="Gender" class="float-field form-control" v-validate="'required'">
                                                   <option value="" disabled>Select Gender</option>
                                                   <option value="F">Female</option>
                                                   <option value="M">Male</option>
                                                   <option value="O">Other</option>
                                               </select>
                                            </div>
                                            <p class="error" v-if="submitted && editProfile && errors.has('Gender')">{{  errors.first('Gender') }}</p>
                                        </div>
                                   </div>
                                   <div class="col-12 col-md-4">
                                        <div class="form-group" :class="[{'border-bottom pb-3':!editProfile}]">
                                            <label>DOB</label>
                                            <p class="mb-0" v-if="!editProfile">
                                                <span v-if="get_user.profile.dob && get_user.profile.dob != '0000-00-00'">{{get_user.profile.dob | moment('DD MMM YYYY')}}</span>
                                                <span v-else>N/A</span>
                                            </p>
                                            <div class="position-relative" v-if="editProfile">
                                                <input type="date" placeholder="Enter DOB" name="DOB" v-model="dob" class="float-field form-control" v-validate="'required'">
                                            </div>
                                            <p class="error" v-if="submitted && editProfile && errors.has('DOB')">{{  errors.first('DOB') }}</p>
                                        </div>
                                   </div>
                                   <div class="col-12 col-md-4">
                                        <div class="form-group" :class="[{'border-bottom pb-3':!editProfile}]">
                                            <label>Phone No</label>
                                            <p class="mb-0" v-if="!editProfile">{{ get_user.mobile_no || 'N/A'}}</p>
                                            <div class="position-relative" v-if="editProfile">
                                               <input type="text" placeholder="Enter Phone No." name="number" v-model="number" class="float-field form-control" v-validate="'required|numeric|min:10'">
                                            </div>
                                            <p class="error" v-if="submitted && editProfile && errors.has('number')">{{  errors.first('number') }}</p>
                                        </div>
                                   </div>
                                </div> 
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group" :class="[{'border-bottom pb-3':!editProfile}]">
                                            <label>City</label>
                                            <p class="mb-0" v-if="!editProfile">{{get_user.profile.city || 'N/A'}}</p>
                                            <div class="position-relative" v-if="editProfile">
                                               <input type="text" placeholder="Enter city" name="city" v-model="city" class="float-field form-control" maxlength="35" v-validate="'required|max:35'">
                                            </div>
                                            <p class="error" v-if="submitted && editProfile && errors.has('city')">{{  errors.first('city') }}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group" :class="[{'border-bottom pb-3':!editProfile}]">
                                            <label>State</label>
                                            <p class="mb-0" v-if="!editProfile">{{get_user.profile.state || 'N/A'}}</p>
                                            <div class="position-relative" v-if="editProfile">
                                               <input type="text" placeholder="Enter State" name="State" v-model="state" class="float-field form-control" maxlength="25" v-validate="'required|max:25'">
                                            </div>
                                            <p class="error" v-if="submitted && editProfile && errors.has('State')">{{  errors.first('State') }}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group" :class="[{'border-bottom pb-3':!editProfile}]">
                                            <label>Zipcode</label>
                                            <p class="mb-0" v-if="!editProfile">{{get_user.profile.post_code || 'N/A'}}</p>
                                            <div class="position-relative" v-if="editProfile">
                                               <input type="text" placeholder="Enter Zipcode" name="Zipcode" v-model="Zipcode" class="float-field form-control" v-validate="'required|numeric|min:6'">
                                            </div>
                                            <p class="error" v-if="submitted && editProfile && errors.has('Zipcode')">{{  errors.first('Zipcode') }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="!editProfile">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group border-bottom pb-3 mb-0">
                                            <label>Height (cm's)</label>
                                            <p class="mb-0">{{(get_user.profile.height)?get_user.profile.height+' cm':'N/A'}}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group border-bottom pb-3 mb-0">
                                            <label>Weight (kg's)</label>
                                            <p class="mb-0">{{get_user.profile.weight || 'N/A'}}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group border-bottom pb-3 mb-0">
                                            <label>Current Diagnosis</label>
                                            <p class="mb-0">N/A<!-- Diabetes --></p>
                                        </div>
                                    </div>
                                </div> 
                                <div class="row" v-if="!editProfile">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group" :class="[{'border-bottom pb-3':!editProfile}]">
                                            <label>Address</label>
                                            <p class="mb-0">{{get_user.profile.address1 || 'N/A'}}</p>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4" v-if="!editProfile">
                                        <div class="form-group border-bottom pb-3">
                                            <label>Registered Date</label>
                                            <p class="mb-0">{{get_user.created | moment('DD MMM YYYY')}}</p>
                                        </div>
                                    </div>
                                </div>  
                                <div class="row" v-if="editProfile">
                                    <div class="col-12">
                                        <a href="javascript:void(0)" class="btn-blue d-inline-flex mt-4" v-on:click="update()">Update</a>
                                    </div>
                                </div>                   
                            </div>  
                            <div class="editProfile">
                                <a href="javascript:void(0)" @click="editFunc()"><feather size="20px" :type="editProfile?'x':'edit'"></feather></a>
                            </div>                     
                        </div>
                    </div>
                </div>
                <div class="bg-white border-radius-5 p-4 mt-4" v-if="get_user.profile.planname != null">
                    <div class="headTitle border-bottom pb-2 mb-4">
                        <h3>{{ get_user.profile.planname }} Package</h3>
                    </div>
                    <div class="reversal">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="chedk d-flex">
                                <feather class="d-flex align-items-center justify-content-center mr-3" type="check"></feather>
                                <span>
                                    <p>Current Plan</p>
                                    <h2>{{ get_user.profile.planname }} </h2>
                                </span>
                            </div>
                            <div class="midAera">
                                <p>Cost</p>
                                <h2>{{ get_user.profile.amount }}</h2>
                            </div>
                            <!-- <div class="midAera costPlan">
                                <router-link to="/membership-plans" class="btn-blue d-flex align-items-center medium">Change Plan</router-link>
                            </div> -->
                        </div>
                    </div>
                    <div class="btmArea mt-4">
                        <h4>{{ get_user.profile.planname }} plan will renew on <span class="themecolor">11 February 2023 </span></h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import moment from 'moment'
    export default {
        name: "Profile",
        data() {
            return {
                pageLoader : false,
                editProfile : false,
                fname : '',
                lname : '',
                gender : '',
                dob : '',
                number : '',
                state : '',
                city : '',
                address : '',
                Zipcode : '',
                submitted : false,
                docSubmitted : false, 
                fileName : '',
            }
        },
        methods:{
            ...mapActions({
                _runstateLoad: types.RUN_STATE_LOAD
            }),
            reset(){
                /*this.gender = ''
                this.dob = ''
                this.fname = ''
                this.lname = ''
                this.number = ''
                this.address = ''
                this.city = ''
                this.state = ''
                this.Zipcode = ''
                this.editProfile = ''*/
                this.fileName = ''
                this.$refs.documemnts.value = ''
                this._runstateLoad({'globalParams' :{},'localParams' :{ "parameter" : this }})
            },
            editFunc(){
                if(this.editProfile){
                    this.editProfile = false
                }else{
                    this.gender = this.get_user.profile.gender || ''
                    this.dob = (this.get_user.profile.dob && this.get_user.profile.dob != '0000-00-00')? moment(this.get_user.profile.dob).format('YYYY-MM-DD'): ''
                    this.fname = this.get_user.profile.firstname || ''
                    this.lname = this.get_user.profile.lastname || ''
                    this.number = this.get_user.mobile_no || ''
                    this.address = this.get_user.profile.address1 || ''
                    this.city = this.get_user.profile.city || ''
                    this.state = this.get_user.profile.state || ''
                    this.Zipcode = this.get_user.profile.post_code || ''
                    this.editProfile = true
                }
            },
            update(){
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json = {
                            'globalParams': {
                                "gender": _that.gender,
                                "dob": _that.dob,
                                "firstname" : _that.fname,
                                "lastname" : _that.lname,
                                "mobile_no" : _that.number,
                                "address" : _that.address,
                                "city" : _that.city, 
                                "state" : _that.state, 
                                "post_code" : _that.Zipcode
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runEditProfile(input_json)
                    }
                })
            },
            onFileChange(event){
                var fileData =  event;
                this.fileName=fileData.name;
                if(this.fileName != ''){
                    const _that = this
                    let Upload = document.getElementById('UploadDocuments');
                    let form_name = new FormData(Upload);
                    let form_data_get = form_name.get('document');
                    _that.docSubmitted = true;
                    // form_name.append("user_id" , parseInt(_that.$route.query.id));
                     // form_name.append("prescription" , _that.prescription);
                    _that.$validator.validate().then(valid => {
                        if (valid) {
                            let inputJson = {
                                'globalParams' : {
                                    "form" : form_name,
                                } ,'localParams' : {'parameter' : _that,'type' :'form'}
                            }
                            if(form_data_get && form_data_get.name != ''){
                                _that._runEditProfilePic(inputJson)
                                _that.docSubmitted = false;
                            }
                        }
                    });
                }
            },
            removeDocument(){
                this.fileName = ''
                this.$refs.documemnts.value = ''
            },
            /*uploadProfilePic(){
                const _that = this
                let Upload = document.getElementById('UploadDocuments');
                let form_name = new FormData(Upload);
                let form_data_get = form_name.get('document');
                _that.docSubmitted = true;
                // form_name.append("user_id" , parseInt(_that.$route.query.id));
                 // form_name.append("prescription" , _that.prescription);
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let inputJson = {
                            'globalParams' : {
                                "form" : form_name,
                            } ,'localParams' : {'parameter' : _that,'type' :'form'}
                        }
                        if(form_data_get && form_data_get.name != ''){
                            _that._runEditProfilePic(inputJson)
                            _that.docSubmitted = false;
                        }
                    }
                });
            },*/
        },
        created(){
            this.pageName('Profile')
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/website/user/profile.vue